/* eslint-disable */
/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 * Run `npm run generate-api` to regenerate.
 */
import { z } from 'zod';

import { zEnumWithUnknownFallback, zRequired } from '@/shared/redux/api/utils/zod-helpers';

export const billingBackofficeValidators: Record<string, z.ZodTypeAny> = {
  "SewSalesExport": z.object({ "sewSalesExport": z.object({ "url": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewCreditConsumptionExport": z.object({ "sewSdaCreditConsumptionExport": z.object({ "url": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewSapExport": z.object({ "sewSapExport": z.object({ "url": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewInternalSapExport": z.object({ "sewInternalSapExport": z.object({ "url": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "SewInternalCostCenterExport": z.object({ "sewInternalCostCenterExport": z.object({ "url": z.string(), "log": z.string().nullish(), "hasErrors": z.boolean().nullish() }) }),
  "ResalePlansExport": z.object({ "resalePlansExport": z.object({ "url": z.string() }) }),
  "ReadTenantsLatestSubscriptions": z.object({ "tenantsLatestSubscriptions": z.array(z.object({ "tenantId": z.string(), "subscription": z.object({ "tier": z.string(), "term": z.object({ "startTs": z.number().int().nullish(), "expirationTs": z.number().int().nullish(), "cancellationTs": z.number().int().nullish() }) }) })) }),
};
